import React from "react";
import { Stage, Layer, Ring } from "react-konva";
import { useMedia } from "../../../utils/useMedia";
import { getClockPos, getSplittedRanges, normalizeRanges, angleToTime } from "../utils";
import { ClockFace } from "../ClockFace";
import { EditableHeatRange } from "./EditableHeatRange";
import { useRingDragging } from "./useRingDragging";
export function ScheduleSlider(_ref) {
  var ranges = _ref.ranges,
      setRanges = _ref.setRanges,
      setHandlerTime = _ref.setHandlerTime;
  var isSmall = useMedia(["(max-width: 420px)"]);
  var SIZE = isSmall ? 288 : 368;
  var RADIUS = isSmall ? 130 : 170;
  var OFFSET = -SIZE / 2;

  var setDisplayTimeByAngle = function setDisplayTimeByAngle(angle) {
    setHandlerTime(angle || angle === 0 ? angleToTime(angle) : null);
  };

  var handleRangesChange = function handleRangesChange(newRanges) {
    setRanges(normalizeRanges(newRanges));
    setDisplayTimeByAngle(null);
  };

  var _useRingDragging = useRingDragging({
    RADIUS: RADIUS,
    ranges: ranges,
    setRanges: setRanges,
    setDisplayTimeByAngle: setDisplayTimeByAngle,
    onRangesChange: handleRangesChange
  }),
      workerType = _useRingDragging.workerType,
      workerState = _useRingDragging.workerState,
      handleDrag = _useRingDragging.handleDrag,
      handleDragEnd = _useRingDragging.handleDragEnd;

  var onLayerClick = function onLayerClick(data) {
    if (ranges.length >= 3) return;
    var pos = data.target.getStage().getPointerPosition();
    var localPos = data.target.toLocalPosition(pos);

    var _getClockPos = getClockPos(localPos),
        angle = _getClockPos.angle,
        distance = _getClockPos.distance;

    var delta = Math.abs(RADIUS - distance);
    if (delta > 20) return;
    var newRanges = getSplittedRanges(ranges, angle);
    if (!newRanges) return;
    handleRangesChange(newRanges);
  };

  return /*#__PURE__*/React.createElement(Stage, {
    width: SIZE,
    height: SIZE,
    offsetX: OFFSET,
    offsetY: OFFSET,
    listening: false
  }, /*#__PURE__*/React.createElement(Layer, null, /*#__PURE__*/React.createElement(ClockFace, {
    clockRadius: RADIUS,
    zeroSeparator: true
  })), /*#__PURE__*/React.createElement(Layer, {
    rotation: -90,
    onClick: onLayerClick,
    onTap: onLayerClick,
    listening: true
  }, /*#__PURE__*/React.createElement(Ring, {
    outerRadius: SIZE / 2 + 5,
    innerRadius: 2 * RADIUS - SIZE / 2 - 5,
    onDragEnd: handleDragEnd,
    dragBoundFunc: handleDrag,
    draggable: true
  }), ranges.map(function (range, index) {
    return /*#__PURE__*/React.createElement(EditableHeatRange, {
      key: index,
      index: index,
      range: range,
      clockRadius: RADIUS
    });
  }), workerType === "NEW_RANGE" && !workerState.outOfBound && /*#__PURE__*/React.createElement(EditableHeatRange, {
    index: null,
    range: workerState,
    clockRadius: RADIUS
  })));
}